/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesMoods {
	MOODS_PANEL = "res://senior.com.br/hcm/moods/panel",
	PULSE = "res://senior.com.br/hcm/moods/dimensionSatisfaction",//ok
	DASHBOARD_STATUS_MANAGER = "res://senior.com.br/hcm/moods/pulseStatusPanel",//ok
	MANAGER_DASHBOARD = "res://senior.com.br/hcm/moods/managerDashboard",
	SCORE_BY_PULSE = "res://senior.com.br/hcm/moods/scoreByPulse", //ok
	NPS_BY_PULSE = "res://senior.com.br/hcm/moods/npsByPulse"
}

/**
 * Cards da página Manager, aba Moods
 */
export enum PermissionResourcesMoodsManager {
	DASHBOARD_STATUS_MANAGER = "res://senior.com.br/hcm/moods/pulseStatusPanel",
	SCORE_BY_PULSE = "res://senior.com.br/hcm/moods/scoreByPulse",
	PULSE = "res://senior.com.br/hcm/moods/dimensionSatisfaction"
}
